module.exports = __webpack_public_path__ + "static/product3_3-74198f755351f6c59cca1f06903499c8.jpg";